module.exports = __webpack_public_path__ + "static/media/default_avatar.f97e6a55.jpg";